import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import DataTable from '../../components/DataTable';
import { ActionButtonWithoutView } from '../../components/ActionButtons';

// Prime-React Components
import { confirmDialog } from 'primereact/confirmdialog';

// Redux-Actions
import {
  deleteCommonParames,
  getCommonParamsById,
  getCommonParamsList
} from '../../redux/actions/commonParameter';

// Constants
import {
  ACTION_TYPE,
  DEBOUNCE_TIMEOUT,
  INITIAL_PAGE_NUMBER,
  INITIAL_SIZE,
  TABLE_NAME
} from '../../constants/common';
import { COMMON_PARAMS_COLUMNS } from '../../constants/tableColumns';

// Utils
import { debounce } from '../../utils/debounce';
import { wordCapitalize } from '../../utils/common';
import AddEditCommonParams from './AddEditCommonParams';

const CommonParameters = () => {
  const dispatch = useDispatch();
  const { parameter } = useSelector((state) => state);
  const [parameterList, setParameterList] = useState([]);
  const [parameterExport, setParameterExport] = useState([]);
  const [parameterId, setParameterId] = useState(null);
  const [tableStates, setTableStates] = useState({
    searchValue: '',
    pageNumber: INITIAL_PAGE_NUMBER,
    size: INITIAL_SIZE,
    sortBy: 'DateModified',
    orderBy: 'desc'
  });

  const [visibleRight, setVisibleRight] = useState(false);
  const onToggleSiderbar = () => setVisibleRight(!visibleRight);

  useEffect(() => {
    dispatch(getCommonParamsList(tableStates));
  }, [
    dispatch,
    tableStates,
    parameter?.isTechnologyDelete,
    parameter?.isUpdated,
    parameter?.isAdded
  ]);

  useEffect(() => {
    const modifiedTechnology = parameter?.data.map((parameter) => {
      return {
        ...parameter,
        Parameters: wordCapitalize(parameter.ParameterName),
        action: (
          <div className="flex align-items-center">
            <ActionButtonWithoutView
              onClick={(actionType) => handleRowActions(actionType, parameter.ID)}
            />
          </div>
        )
      };
    });
    setParameterList(modifiedTechnology);
  }, [parameter]);

  useEffect(() => {
    const modifiedTechnology = parameter?.data.map((parameter) => {
      return {
        Parameters: wordCapitalize(parameter.ParameterName)
      };
    });
    setParameterExport(modifiedTechnology);
  }, [parameter]);

  const handlePagination = (pageNumber, size) =>
    setTableStates((prevState) => {
      return {
        ...prevState,
        pageNumber,
        size
      };
    });

  const handleSearch = (searchValue) => {
    setTableStates((prevState) => {
      return {
        ...prevState,
        searchValue
      };
    });
  };

  const handleSort = (sortBy) => {
    setTableStates((prevState) => {
      return {
        ...prevState,
        sortBy,
        orderBy: prevState.orderBy === 'asc' ? 'desc' : 'asc'
      };
    });
  };

  const handleRowActions = (actionType, rowId) => {
    if (actionType === ACTION_TYPE.EDIT) {
      onToggleSiderbar();
      setParameterId(rowId);
      dispatch(getCommonParamsById(rowId));
      document.body.classList.add('sidebar-open');
    } else if (actionType === ACTION_TYPE.DELETE) {
      confirmDialog({
        header: 'Delete',
        message: 'Are you sure you want to delete?',
        icon: 'pi pi-exclamation-triangle',
        accept: () => dispatch(deleteCommonParames(rowId))
      });
    }
  };

  const handleAdd = () => {
    setParameterId(null);
    onToggleSiderbar();
    setVisibleRight(true);
    document.body.classList.add('sidebar-open');
  };

  return (
    <>
      <AddEditCommonParams ID={parameterId} onHide={onToggleSiderbar} show={visibleRight} />
      <DataTable
        name={TABLE_NAME.COMMON_PRAMETERS}
        searchPlaceHolder="Search by Feedback parameter"
        columns={COMMON_PARAMS_COLUMNS}
        data={parameterList}
        exportData={parameterExport}
        totalRecords={parameter?.pagination?.totalRecords}
        onPagination={handlePagination}
        onSearch={debounce(handleSearch, DEBOUNCE_TIMEOUT)}
        onAdd={() => handleAdd()}
        onSort={handleSort}
      />
    </>
  );
};

export default CommonParameters;
